import { Component, Input } from '@angular/core';

@Component({
  selector: 'users-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
  standalone: false,
})
export class ListViewComponent {
  @Input() users: app.models.Users[];
  @Input() props: app.models.DynamicPropsDictionary;

  @Input() deleteUser: any;
  @Input() viewDetails: any;
  @Input() changeUserStatus: any;
  @Input() redirectUserDetails: any;
  @Input() redirectUserRights: any;
}
